const baseUrl = '/resident';
export const residentRoutes = {
  balance: residencyId => "".concat(baseUrl, "/").concat(residencyId, "/balance"),
  accountBalance: accountId => "".concat(baseUrl, "/balance/").concat(accountId)
};